import styled from 'styled-components'
import { InlineButton } from 'components/button'

export const UnsetButton = styled(InlineButton)`
    font-size: 14px;
    line-height: 24px;
`